<template>
    <pdf-report-viewer
        v-if="pdfDetails"
        :pdf-details="pdfDetails"
        :no-breadcrumb="props.noBreadcrumb"
        :display-mode="props.displayMode"
        :allow-comments-expand="props.allowCommentsExpand"
        :show-initial-loader="false"
        @initialised="emit('loaded')"
    />
    <no-pdf-view v-else-if="!isLoading" />
</template>

<script lang="ts" setup>

import { IPdfDetails } from '@/interfaces/deltaGpt/IDocument.ts';
import NoPdfView from '@/views/404View.vue';
import { ref } from 'vue';
import { deltaGptApi } from '@/api/deltaGpt/deltaGptApi.ts';
import PdfReportViewer from './PdfReportViewer.vue';

const emit = defineEmits<{
    loaded: [];
}>();

const props = withDefaults(defineProps<{
    documentShortCode: string;
    noBreadcrumb?: boolean;
    displayMode?: 'page' | 'modal';
    allowCommentsExpand?: boolean;
}>(), {
    noBreadcrumb: false,
    displayMode: 'page',
    allowCommentsExpand: true,
});

const pdfDetails = ref<IPdfDetails | undefined>();
const isLoading = ref<boolean>(false);

async function initialise (): Promise<void> {
    isLoading.value = true;
    try {
        pdfDetails.value = await deltaGptApi.getPdfDetails(props.documentShortCode);
    } finally {
        isLoading.value = false;
        if (!pdfDetails.value) emit('loaded');
    }
}

initialise();

</script>
